/** @jsx jsx */
import { Button, Flex, Grid, jsx } from "theme-ui";
import React, { Fragment, useState } from "react";

import Trip from "./trip";
import { useStaticQuery, graphql } from "gatsby";

export type ContentTimetableProps = {};
export const ContentTimetable: React.FC<ContentTimetableProps> = ({}) => {
  const data = useStaticQuery(graphql`
    query Timetables {
      allBuilderModels {
        timetable {
          data {
            trips
          }
        }
      }
      allFile(filter: { sourceInstanceName: { eq: "timetables" } }) {
        edges {
          node {
            csv {
              content
            }
            name
            relativePath
          }
        }
      }
    }
  `);

  const { allBuilderModels, allFile } = data;

  const trips = allBuilderModels.timetable[0].data.trips;

  const [activeTrip, setActiveTrip] = useState(trips[0].heading);
  const filterButtons = trips.map((trip) => (
    <Button
      key={`${trip.heading}-button`}
      bg={activeTrip === trip.heading ? "primary" : "white"}
      color={activeTrip === trip.heading ? "white" : "primary"}
      onClick={() => setActiveTrip(trip.heading)}
    >
      {trip.heading}
    </Button>
  ));

  const tripComponents = trips.map((trip) => {
    const data = allFile.edges
      .filter(
        (e) =>
          e.node.name.toLowerCase() === trip.fileName.toLowerCase() ||
          e.node.relativePath.toLowerCase() === trip.fileName.toLowerCase()
      )
      .flatMap((r) => r.node.csv.content); //handles if the extension isincluded
    //console.log("data", data[0]);
    return (
      <Fragment  key={trip.heading}>
        {activeTrip === trip.heading && (
          <Trip
            key={trip.heading}
            heading={trip.heading}
            dataFile={data[0]}
          ></Trip>
        )}
      </Fragment>
    );
  });

  return (
    <Flex sx={{ flexDirection: "column" }}>
      <Grid columns={[2, 4]}>{filterButtons}</Grid>
      {tripComponents}
    </Flex>
  );
};

export default ContentTimetable;
